import React, { useState } from 'react';
import { LuChevronDown, LuChevronUp, LuMapPin, LuBus, LuFootprints, LuExternalLink } from 'react-icons/lu';
import MapaLeaflet, { linkRuta } from '../mapa/MapaLeaflet';
import { Plata, km, horas, fechaLarga } from './comun';

// Un día (real o planificado): números arriba y, al abrirlo, el recorrido en mapa y tramo por tramo.
export default function DiaRecorrido({ titulo, dia, base, precio = null, abiertoInicial = false }) {
    const [abierto, setAbierto] = useState(abiertoInicial);
    const r = dia.recorrido;
    const paradas = dia.paradas || [];
    const conPos = paradas.filter(p => p.lat != null);
    const puntos = [
        { id: 'base', lat: base.lat, lng: base.lng, color: '#111827', etiqueta: 'B' },
        ...conPos.map((p, i) => ({ id: `p-${i}`, lat: p.lat, lng: p.lng, color: '#C9341F', etiqueta: String(i + 1) })),
    ];
    const lineas = conPos.length ? [[base.lat, base.lng], ...conPos.map(p => [p.lat, p.lng]), [base.lat, base.lng]] : null;
    const ruta = linkRuta(conPos);

    return (
        <div className="rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] overflow-hidden">
            <button type="button" onClick={() => setAbierto(a => !a)} className="w-full p-3.5 text-left active:bg-panel">
                {/* 28-oct-2026: la cuenta a la vista: equipos × precio − pasajes = te queda, y en cuánto tiempo */}
                <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                        <p className="text-body font-black text-ink">{titulo || fechaLarga(dia.fecha)}</p>
                        <p className="text-caption text-secondary">
                            {precio ? <>{dia.equipos} equipo{dia.equipos !== 1 ? 's' : ''} × <Plata v={precio} /></> : <>{dia.equipos} equipo{dia.equipos !== 1 ? 's' : ''}</>}
                            {r.pasajes > 0 ? <> − <Plata v={r.pasajes} /> de pasajes</> : null}
                        </p>
                        <p className="text-caption text-muted">
                            {horas(dia.horasReales ?? dia.horasEstimadas ?? r.minutosTotal / 60)}{dia.horasReales != null ? '' : ' (estimado)'}
                            {dia.porHora ? <> · <b className="text-ink"><Plata v={dia.porHora} /></b> por hora</> : null}
                        </p>
                    </div>
                    <div className="text-right shrink-0">
                        <Plata v={dia.ganancia} className="block text-body-lg font-black text-ink" />
                        <span className="text-caption text-muted">te queda</span>
                    </div>
                </div>
                <span className="mt-1.5 flex justify-center text-muted">{abierto ? <LuChevronUp size={16} /> : <LuChevronDown size={16} />}</span>
            </button>

            {abierto && (
                <div className="px-3.5 pb-3.5 space-y-3">
                    <p className="text-caption text-secondary">{paradas.length} lugar{paradas.length !== 1 ? 'es' : ''} · {km(r.km)} · pasajes <b className="text-ink"><Plata v={r.pasajes} /></b></p>
                    {conPos.length > 0 && <MapaLeaflet puntos={puntos} lineas={lineas} ajustarKey={`${titulo}-${dia.fecha}-${conPos.length}`} className="h-56 rounded-xl overflow-hidden" />}
                    <ol className="space-y-1">
                        <li className="flex items-center gap-2 text-caption text-muted"><LuMapPin size={13} /> Salida: {base.nombre}</li>
                        {r.tramos.map((t, i) => (
                            <li key={i} className="flex items-center gap-2 text-caption">
                                <span className="w-5 h-5 rounded-full shrink-0 flex items-center justify-center text-label font-black text-white"
                                    style={{ background: i < paradas.length ? '#C9341F' : '#111827' }}>{i < paradas.length ? i + 1 : 'B'}</span>
                                <span className="flex-1 min-w-0 truncate text-ink font-bold">
                                    {t.hasta}{i < paradas.length && paradas[i]?.equipos > 1 ? ` · ${paradas[i].equipos} eq.` : ''}
                                </span>
                                <span className="shrink-0 text-muted inline-flex items-center gap-1">
                                    {t.pasaje ? <LuBus size={12} /> : <LuFootprints size={12} />}{km(t.km)} · {t.minutos}′ · <Plata v={t.pasaje} />
                                </span>
                            </li>
                        ))}
                    </ol>
                    {r.sinUbicar > 0 && <p className="text-caption text-[var(--warning-tx)]">{r.sinUbicar} lugar(es) sin ubicar en el mapa: no suman km.</p>}
                    {dia.salida && dia.fin && (
                        <p className="text-caption text-muted">Registrado en la app: salió {String(dia.salida).slice(11, 16)} · terminó {String(dia.fin).slice(11, 16)}</p>
                    )}
                    {ruta && (
                        <a href={ruta} target="_blank" rel="noreferrer"
                            className="h-10 rounded-xl bg-chip text-ink text-label font-black inline-flex w-full items-center justify-center gap-1.5 active:scale-95">
                            <LuExternalLink size={14} /> Ver en Google Maps
                        </a>
                    )}
                </div>
            )}
        </div>
    );
}
